/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Section_01_TitleInputs */

const en_landing_section_01_title = /** @type {(inputs: Landing_Section_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job applications at full throttle.`)
};

const de_landing_section_01_title = /** @type {(inputs: Landing_Section_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerbungen auf Hochtouren.`)
};

const fr_landing_section_01_title = /** @type {(inputs: Landing_Section_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job applications at full throttle.`)
};

const es_landing_section_01_title = /** @type {(inputs: Landing_Section_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job applications at full throttle.`)
};

const it_landing_section_01_title = /** @type {(inputs: Landing_Section_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job applications at full throttle.`)
};

const nl_landing_section_01_title = /** @type {(inputs: Landing_Section_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job applications at full throttle.`)
};

const pl_landing_section_01_title = /** @type {(inputs: Landing_Section_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job applications at full throttle.`)
};

const fi_landing_section_01_title = /** @type {(inputs: Landing_Section_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job applications at full throttle.`)
};

const da_landing_section_01_title = /** @type {(inputs: Landing_Section_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job applications at full throttle.`)
};

const sv_landing_section_01_title = /** @type {(inputs: Landing_Section_01_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job applications at full throttle.`)
};

/**
* | output |
* | --- |
* | "Job applications at full throttle." |
*
* @param {Landing_Section_01_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_section_01_title = /** @type {((inputs?: Landing_Section_01_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Section_01_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_section_01_title(inputs)
	if (locale === "fr") return fr_landing_section_01_title(inputs)
	if (locale === "es") return es_landing_section_01_title(inputs)
	if (locale === "it") return it_landing_section_01_title(inputs)
	if (locale === "nl") return nl_landing_section_01_title(inputs)
	if (locale === "pl") return pl_landing_section_01_title(inputs)
	if (locale === "fi") return fi_landing_section_01_title(inputs)
	if (locale === "da") return da_landing_section_01_title(inputs)
	if (locale === "sv") return sv_landing_section_01_title(inputs)
	return en_landing_section_01_title(inputs)
});